import templateCollection from "@/vuex/modules/template-collection.module"
import scimApiKey from "@/vuex/modules/scim-api-key.module"
import presentations from "@/vuex/modules/presentations.module"
import marketplaceLicense from "@/vuex/modules/marketplace-license.module"
import serviceTokens from "@/vuex/modules/service-tokens.module"

export default {
  templateCollection,
  scimApiKey,
  presentations,
  marketplaceLicense,
  serviceTokens,
}